import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

import type {AttributeId} from '../types';

/**
 * `metadataDatasetAutoList` request params
 * (what is used to send to server)
 */
export type MetadataDatasetAutoListRequestOptions = {
	id: AttributeId;
	value: string;
};

/**
 * `metadataDatasetAutoList` request
 * (what gets sent to the server)
 */
export type MetadataDatasetAutoListRequest = [
	MetadataDatasetAutoListRequestOptions['id'],
	MetadataDatasetAutoListRequestOptions['value'],
];

/**
 * `metadataDatasetAutoList` response
 * (what comes back from the server)
 */
export type MetadataDatasetAutoListResponse =
	SuccessResponse<MetadataDatasetAutoListResult>;

/**
 * `metadataDatasetAutoList` result
 * (what is utilized from the server response)
 */
export type MetadataDatasetAutoListResult = string[];

export const metadataDatasetAutoListEndpoint = 'metadataDatasetAutoList';

/**
 * Metadata dataset auto list
 */
export const metadataDatasetAutoList = async ({
	id,
	value,
}: MetadataDatasetAutoListRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: MetadataDatasetAutoListRequest = [id, value];

	return client
		.post<MetadataDatasetAutoListResponse>(
			metadataDatasetAutoListEndpoint,
			requestParams,
		)
		.then((response) => response.data.result);
};

export default metadataDatasetAutoList;
